import { render, staticRenderFns } from "./TransferOrderList.vue?vue&type=template&id=1944b5ab&scoped=true"
import script from "./TransferOrderList.vue?vue&type=script&lang=js"
export * from "./TransferOrderList.vue?vue&type=script&lang=js"
import style0 from "./TransferOrderList.vue?vue&type=style&index=0&id=1944b5ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944b5ab",
  null
  
)

export default component.exports